import * as types from "./actionTypes"

const initialState = {
    dashboard: [],
    filter: {},
}

export default function dashboardReducer(state = initialState, action) {
    let widget =
        action.payload && action.payload.widget
            ? { [action.payload.widget]: action.payload.data }
            : null

    switch (action.type) {
        case types.DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                dashboard: action.payload,
            }
        case types.DASHBOARD_FILTER_SET:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...widget,
                },
            }

        case types.DASHBOARD_FILTER_CLEAR:
            return {
                ...state,
                filter: {},
            }

        default:
            return state
    }
}
